$(function () {
    $('section').prepend('<div class="sitenav sitenav-hidden"><ul></ul></div>');

    let UISiteNav = $("div.sitenav");
    let UISiteNavScroll = "1024";
    let UISiteNavUl = UISiteNav.find('ul');
    let activeAnchor = window.location.hash.substr(1);

    $('article a.anchor-link').each(function () {
        if ($(this).attr('name')) {
            UISiteNavUl.append(
                '<li><a class="chapter" href="#' + $(this).attr('name')
                + '">•</a></li>');
        }
    });

    $(window).scroll(function(e) {
        if ($(this).scrollTop() > UISiteNavScroll) {
            UISiteNav.removeClass("sitenav-hidden");
        } else {
            UISiteNav.addClass("sitenav-hidden");
        }

        var htmlPos = $(window).scrollTop();
        htmlPos = Math.round(htmlPos);
        // alle anker durchgehen
        $("article a.anchor-link").each(function(){
            var UIAnchorHash = $(this).attr("name");
            var UIAnchorPos = $(this).offset().top;
            UIAnchorPos = Math.round(UIAnchorPos);
            //  checken ob siete im bereich +/- 150 px vom a tah ist, dann UIAnchorHash setzen
            if ( htmlPos <= UIAnchorPos+150 && htmlPos >= UIAnchorPos-150 ) {
                //window.location.hash = UIAnchorHash;
                activeAnchor = UIAnchorHash;
            }
        });

        // alle dots entfernen
        //UISiteNav.find("a.chapter").removeClass("aktiv");
        var UIChapterDot = activeAnchor;
        // alle links durchgehen + aktiven Dot fÃ¤rben
        UISiteNav.find("a.chapter").each(function(){
            if ($(this).attr("href").substr(1) === UIChapterDot) {
                $(this).addClass("aktiv");
            } else {
                $(this).removeClass("aktiv");
            }
        });
    }).trigger('scroll');

    // bei klick im index
    $("body.sustainability-report article.fst ul.factsheetlist li a").on("click", function(event){
        event.preventDefault();
        // soll zu hash scrollen
        var hash = $(this).attr("href").substring(1);
        var hashElement = $("a[name='"+ hash +"']");
        $("html, body").animate({ scrollTop: hashElement.offset().top - 120 }, 500);
    });

    // bei klick auf Dots
    UISiteNav.find("a.chapter").on("click", function(event){
        event.preventDefault();
        //UISiteNav.find("a.chapter").removeClass("aktiv");
        var hash = $(this).attr("href").substring(1);
        var hashElement = $("a[name='"+ hash +"']");
        $("html, body").animate({ scrollTop: hashElement.offset().top - 120 }, 500, function(){
            // hash wird ausgetauscht
            window.location.hash = hash;
        });
        // dot wird aktiv gesetzt
        //$(this).addClass("aktiv");
    });



    $('article .readmore').on('click', function () {
        $(this).parent('article').css('height', 'inherit');
        $(this).siblings('.fade').remove();
        $(this).nextAll().removeClass('hide');
        $(this).remove();
    });

    $('.readmore').closest('article').addClass('text-preview');
    $('.readmore').nextAll().addClass('hide');
});